import { render, staticRenderFns } from "./MenuPaquetes.vue?vue&type=template&id=f4f660a8&scoped=true"
import script from "./MenuPaquetes.vue?vue&type=script&lang=js"
export * from "./MenuPaquetes.vue?vue&type=script&lang=js"
import style0 from "./MenuPaquetes.vue?vue&type=style&index=0&id=f4f660a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f660a8",
  null
  
)

export default component.exports